export const PAYER_IDENTITY_RECIPIENTS = [
  'PTU',
  'FWU',
  'PTR',
  'ACM',
  'ARA',
  'ARCNE',
];
export const PAYER_IDENTITY_COUNTRIES = ['GB'];
